<template>
  <section>
    <h2 class="h2Title">{{currentStateName}} 회원 관리</h2>
    <article class="fieldMb">
      <form class="fieldWrap">
        <div class="fieldBx">
          <ul>
            <li class="formList">
              <dl>
                <dd>
                  <v-select :items="departmentItems" item-value="groupId" item-text="groupName" v-model="param.searchDepartment"
                            dense
                            clearable
                            flat
                            outlined
                            label="분과"
                            v-on:change="search"/>
                </dd>
              </dl>
              <dl>
                <dd>
                  <v-select :items="clubItems" item-value="groupId" item-text="groupName" v-model="param.searchClub"
                            dense
                            clearable
                            flat
                            outlined
                            label="동호회"
                            v-on:change="search"/>
                </dd>
              </dl>
              <dl>
<!--                <dt class="formTit">역할</dt>-->
                <dd>
                  <v-select v-model="param.searchRole" :items="userRoleItems" item-text="roleName"
                            item-value="roleId" label="역할"
                            dense
                            clearable
                            flat
                            outlined
                            v-on:change="search"
                  />
                </dd>
              </dl>
              <dl>
                <dd>
                  <v-select v-model="param.searchState" :items="userStateItems" label="회원 상태"
                            dense
                            clearable
                            flat
                            outlined
                            v-on:change="search"
                            v-if="!this.$route.params.state"
                  />
                </dd>
              </dl>
              <dl>
<!--                <dt class="formTit">회원정보</dt>-->
                <dd>
<!--                  <v-col class="d-flex mgr" sm="1">-->
<!--                    <v-select v-model="param.keyType" :items="param.textType" label="이름" dense solo flat-->
<!--                              outlined/>-->
<!--                  </v-col>-->
                  <v-col sm="6">
                    <v-text-field label="이메일/아이디/이름/휴대폰번호 검색"
                                  v-model="searchValue"
                                  v-on:keyup.enter="search"
                                  dense clearable flat outlined
                    />
                  </v-col>
                </dd>
              </dl>
            </li>
            <li class="formList">
              <dl>
                <!--                <dt class="formTit">가입일</dt>-->
                <dd>
                  <date-range-component v-on:event="getSearchDate" label="가입일" :value="searchDate"></date-range-component>
                </dd>
                <dd>
                  <div class="monthBx">
                    <button type="button" class="btn month" v-for="(month, idx) in monthLists"
                            :class="{ active: month === activeItem}"
                            @click="selectItem(month.value, idx)" :key="idx">{{ month.text }}
                    </button>
                  </div>
                </dd>
              </dl>

            </li>
          </ul>
<!--          <div class="searchBtn">-->
<!--            <v-btn color="#424964" @click="search()" depressed dark>검색</v-btn>-->
<!--          </div>-->
        </div>
      </form>
    </article>
    <article class="tableWrap">
      <div class="tableBtnBx">
        <p class="searchAll">
          <v-checkbox class="mgr" label="" v-model="all" :true-value="true" :false-value="false">
            <template v-slot:label>검색 된 총 <span class="txtPoint"> {{ totalItems }}명 </span> 선택</template>
          </v-checkbox>
        </p>
        <div class="tableBtn">
          <ul>
            <li class="tableBtnList" v-if="!all">
              <span class="black-color">{{ selected != null ? selected.length : 0 }}</span> 명 선택됨
            </li>
            <li class="tableBtnList" v-if="all"><span class="red--text">검색된 전체 회원 선택됨</span></li>

<!--            <li class="tableBtnList"><span class="black-color">{{ selected.length }}</span> 건 선택됨</li>-->
            <li class="tableBtnList">
              <v-btn color="#58d8a3" depressed dark @click="smsDialogVisible=true">SMS 발송</v-btn>
            </li>
            <li class="tableBtnList">
              <v-btn color="#ffc105" depressed dark @click="mailDialogVisible=true">Mail 발송</v-btn>
            </li>
            <li class="tableBtnList" v-if="!this.$route.params.state || this.$route.params.state === 'STATE_REQUEST' ||  this.$route.params.state === 'STATE_DORMANT' || this.$route.params.state === 'STATE_EXAMINATION' ">
              <v-btn color="primary" depressed dark @click="updateState('STATE_NORMAL')"><v-icon left dark small>mdi mdi-check</v-icon>{{ $route.params.state === 'STATE_DORMANT' ? '해제':'승인' }}</v-btn>
            </li>
            <li class="tableBtnList" v-if="!this.$route.params.state">
              <v-btn color="primary" depressed dark @click="updateState('STATE_REQUEST')"><v-icon left dark small>mdi mdi-hand-right</v-icon>대기</v-btn>
            </li>
            <li class="tableBtnList" v-if="!this.$route.params.state || this.$route.params.state === 'STATE_REQUEST'">
              <v-btn color="primary" depressed dark @click="updateState('STATE_EXAMINATION')"><v-icon left dark small>mdi mdi-feature-search</v-icon>심사중</v-btn>
            </li>
            <li class="tableBtnList" v-if="!this.$route.params.state || this.$route.params.state === 'STATE_REQUEST' || this.$route.params.state === 'STATE_EXAMINATION'">
              <v-btn color="primary" depressed dark @click="updateState('STATE_REJECT')"><v-icon left dark small>mdi mdi-file-cancel</v-icon>반려</v-btn>
            </li>
            <li class="tableBtnList" v-if="!this.$route.params.state">
              <v-btn color="primary" depressed dark @click="updateState('STATE_DORMANT')"><v-icon left dark small>mdi mdi-sleep</v-icon>휴면</v-btn>
            </li>
            <li class="tableBtnList" v-if="!this.$route.params.state">
              <v-btn color="primary" depressed dark @click="updateState('STATE_WITHDRAW_REQUEST')"><v-icon left dark small>mdi mdi-account-minus-outline</v-icon>탈퇴 대기</v-btn>
            </li>
            <li class="tableBtnList" v-if="!this.$route.params.state || this.$route.params.state === 'STATE_WITHDRAW_REQUEST'">
              <v-btn color="primary" depressed dark @click="updateState('STATE_WITHDRAW')"><v-icon left dark small>mdi mdi-account-minus</v-icon>탈퇴</v-btn>
            </li>
            <li class="tableBtnList" v-if="!this.$route.params.state">
              <v-btn color="primary" depressed dark @click="updateState('STATE_BLOCKED')"><v-icon left dark small>mdi mdi-account-off</v-icon>차단</v-btn>
            </li>
            <li class="tableBtnList">
              <v-btn color="#607d8b" depressed dark @click="excel">
                <v-icon left dark>cloud_download</v-icon>
                엑셀 다운로드
              </v-btn>
            </li>
            <li class="tableBtnList">
              <v-btn class="vBtn vIconResize mgr" @click="createForm" color="#666" dark>
                <v-icon left>mdi mdi-playlist-plus</v-icon>
                등록
              </v-btn>
            </li>
          </ul>
        </div>
      </div>
      <div class="tableBx">
        <v-data-table
            v-model="selected"
            :headers="headers"
            :items="users"
            :server-items-length="totalItems"
            :options.sync="options"
            item-key="userId"
            show-select
            class="elevation-1"
            :footer-props="{showFirstLastPage: true}"
            disable-sort
        >


          <template v-slot:item.state="{value}">
            {{ userStateItems.filter(i => i.value === value)[0].text }}
          </template>
          <template v-slot:item.userHasRoles="{value}">
<!--            {{ $t(value) }}-->
            <span
                class="d-inline-block text-truncate"
                style="max-width: 100px;"
            >
              {{ value.length > 0 ? value.length > 1 ? value[0].role.roleName + ' 외 ' + (value.length-1)  : value[0].role.roleName : '' }}
<!--              <template v-for="(role, index) in item.userHasRoles"><span v-if="index !== 0"  :key="index">, </span>{{role.role.roleName}}</template>-->
            </span>

          </template>
          <template v-slot:item.userId="{value}">
            <a @click.stop="onRowClick(value)">
            {{ value }}
            </a>
          </template>
          <template v-slot:item.birthDate="{value, item}">
            {{ value }} {{ value != null ? item.lunarBirth ? '(음력)' : '(양력)' : '' }}
          </template>
          <template v-slot:item.departmentGroup="{value, item}">
            <a @click.stop="groupSetting(item)" v-if="value && value.findIndex(e => e.joinState === 'STATE_REQUEST') === -1">{{  groupName(value) }}</a>
            <a @click.stop="groupSetting(item)" v-else>대기중</a>
          </template>
          <template v-slot:item.clubGroup="{value, item}">
            <a @click.stop="groupSetting(item)" v-if="value && value.findIndex(e => e.joinState === 'STATE_REQUEST') === -1">{{  groupName(value) }}</a>
            <a @click.stop="groupSetting(item)" v-else>대기중</a>
          </template>

          <template v-slot:item.createdAt="{ value }">
            {{ value | moment('YYYY-MM-DD HH:mm:ss') }}
          </template>
          <template v-slot:item.stateChangedAt="{ value }">
            {{ value | moment('YYYY-MM-DD HH:mm:ss') }}
          </template>
          <template v-slot:item.stateChange="{item}">
            <v-btn color="primary" small dark @click="updateState('STATE_NORMAL', item.userId)">{{ $route.params.state === 'STATE_DORMANT' ? '해제':'승인' }}</v-btn>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon
                small
                class="mr-2"
                @click.stop="updateForm(item)"
            >
              mdi-pencil
            </v-icon>
            <v-icon
                small
                @click.stop="deleteUser(item)"
            >
              mdi-delete
            </v-icon>
          </template>


        </v-data-table>

        <v-dialog v-model="smsDialogVisible" max-width="350px" @click:outside="smsDialogVisible = false" @keydown.esc="smsDialogVisible = false">
          <v-card class="mx-auto">
            <v-system-bar>
              SMS 발송
              <v-spacer></v-spacer>
              <v-icon @click="smsDialogVisible = false">mdi-close</v-icon>
            </v-system-bar>
            <v-card-text>

              <mobile-component
                  :param="param"
                  :all-selected="all"
                  :selected="selected"
                  @callback-event = "v => smsDialogVisible = !v"
              />

            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="mailDialogVisible" max-width="600px" @click:outside="mailDialogVisible = false" @keydown.esc="mailDialogVisible = false">
          <v-card class="mx-auto">
            <v-system-bar>
              메일 발송
              <v-spacer></v-spacer>
              <v-icon @click="mailDialogVisible = false">mdi-close</v-icon>
            </v-system-bar>
            <v-card-text>

              <mail-component
                  :param="param"
                  :all-selected="all"
                  :selected="selected"
                  :is-part="true"
                  @callback-event = "v => mailDialogVisible = !v"
              />

            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </article>

<!--    <user-form-->
<!--        :is-visible="dialogVisible"-->
<!--        :item="selectedUser.userId"-->
<!--        @callback-cancel="dialogVisible = false"-->
<!--        @callback-saved="savedUser"-->
<!--    />-->
    <user-group
        :is-visible="groupDialogVisible"
        :item="selectedUser"
        @callback-cancel="groupDialogVisible = false"
        @callback-changed="changedUserGroupState"
    />
  </section>
</template>

<script>
import DateRageComponent from "@/views/component/DateRageComponent";
import mobileComponent from "@/views/component/MobileComponent";
import mailComponent from "@/views/component/MailComponent";

// import UserForm from "./UserForm";
import UserGroupForList from "./UserGroupForList";

import userApi from '@/api/UserApi'
import roleApi from '@/api/RoleApi'
import groupApi from "@/api/GroupApi";

import _ from "lodash";

export default {
  name: "User",
  components: {
    'date-range-component': DateRageComponent,
    // 'user-form': UserForm,
    'user-group': UserGroupForList,
    mobileComponent,
    mailComponent
  },
  data: () => ({
    date: new Date(),
    // fromDate: new Date().toISOString().substr(0, 10),
    // toDate: new Date().toISOString().substr(0, 10),
    menu: false,
    menu2: false,
    userRoleItems: [],
    userStateItems: [
      {text: '승인', value: 'STATE_NORMAL'},
      {text: '대기', value: 'STATE_REQUEST'},
      {text: '심사중', value: 'STATE_EXAMINATION'},
      {text: '반려', value: 'STATE_REJECT'},
      {text: '탈퇴', value: 'STATE_WITHDRAW'},
      {text: '탈퇴대기', value: 'STATE_WITHDRAW_REQUEST'},
      {text: '휴면', value: 'STATE_DORMANT'},
      {text: '차단', value: 'STATE_BLOCKED'}
    ],
    keywordType: ['아이디', '이름', '닉네임', '휴대폰'],
    monthLists: [
      {value: 1, text: '1개월'}, {value: 3, text: '3개월'}, {value: 6, text: '6개월'},
      {value: 12, text: '1년'}, {value: 0, text: '전체'}],
    monthOn: false,
    activeItem: null,
    emailType: [{value: null, text: '전체'}, {value: true, text: 'Y'}, {value: false, text: 'N'}],
    smsType: [{value: null, text: '전체'}, {value: true, text: 'Y'}, {value: false, text: 'N'}],
    selected: [],
    headers: [
      {text: '역할', value: 'userHasRoles', sortable: false, align: 'left'},
      {text: '이름', value: 'name', sortable: false, align: 'left'},
      {text: '아이디', value: 'userId', sortable: false, align: 'left'},
      {text: '부서', value: 'retirementDepartment', sortable: false, align: 'left'},
      {text: '생년월일', value: 'birthDate', sortable: false},
      {text: '이메일', value: 'email', sortable: false, align: 'left'},
      {text: '휴대폰번호', value: 'mobileNo', sortable: false},
      {text: '분과', value: 'departmentGroup', sortable: false, align: 'left'},
      {text: '동호회', value: 'clubGroup', sortable: false, align: 'left'},
      {text: '가입일', value: 'createdAt', sortable: false},
      {
        text: '관리',
        value: 'actions',
        align: 'center',
        sortable: false
      }
    ],
    param: {
      searchState: null,
      searchRole: null,
      keyType: null,
      searchKeyword: null,
      username: null,
      name: null,
      local: null,
      fromJoin: null,
      toJoin: null,
      sms: null,
      page: 1,
      searchGroup: null,
      searchDepartment: null,
      searchClub: null,
    },
    options: {},
    users: [],
    totalItems: 0,
    searchDate: [],
    dialogVisible: false,
    groupDialogVisible: false,
    smsDialogVisible: false,
    mailDialogVisible: false,
    selectedUser: {},
    waitingSearch: false,
    searchValue: null,
    currentStateName:'전체',
    departmentItems:[],
    clubItems:[],
    all: false
  }),
  watch: {
    options: {
      handler () {
        this.search();
      },
      deep: true,
    },
    searchValue: {
      handler(nv) {
        this.param.searchKeyword = nv;
        if (!this.waitingSearch) {
          setTimeout(() => {
            this.search();
            this.waitingSearch = false;
          }, 500); // 0.5 sec delay
        }
        this.waitingSearch = true;
      }
    },
  },
  methods: {
    groupName(value) {
      // value.filter(v => v.joinState === 'STATE_APPROVAL').length > 1 ? value[0].groupName + ' 외 ' + (value.filter(v => v.joinState === 'STATE_APPROVAL').length-1) : value.filter(v => v.joinState === 'STATE_APPROVAL').length > 0 ? value.filter(v => v.joinState === 'STATE_APPROVAL')[0].groupName : ''
      const approvalList = value.filter(v => v.joinState === 'STATE_APPROVAL');
      const approvalSize = approvalList.length;
      const masterGroup = approvalList?.[0]?.groupName??'';

      return masterGroup + (approvalSize > 1 ? ' 외 ' + (approvalSize-1) : '')
    },
    onRowClick(value) {
      // this.$router.push({path:`/user/${value}`});
      this.$router.push({path: `/user/form/${value}`})
    },
    initSearch() {
      for (const [key] of Object.entries(this.param)) {
        this.param[key] = '';
      }
    },
    getSearchDate(searchDate = []) {
      this.searchDate = searchDate;
      this.search();
    },
    selectItem(months) {
      this.activeItem = months;
      this.searchDate = [];
      if (this.activeItem !== 0) {
        this.searchDate.push(this.$moment().subtract(months, "months").format('YYYY-MM-DD'));
        this.searchDate.push(this.$moment().format('YYYY-MM-DD'));
      }
      this.search();
    },
    search() {
      const params = this.generateParameters();

      userApi.list(params).then(data => {
        this.users = data.content;
        this.totalItems = data.totalElements;
        this.$store.commit('setParams', params);
      });

      this.waitingSearch = false;
    },
    generateParameters() {
      delete this.options.searchKeyword;
      delete this.options.searchDepartment;
      delete this.options.searchClub;
      delete this.options.searchRole;
      delete this.options.searchState;
      const params = {...this.param, ...this.options};
      if(params.searchDate) {
        this.searchDate = params.searchDate;
      }
      // if (this.activeItem > 0) {
      if (this.searchDate) {
        // params.fromJoin = this.fromDate;
        // params.toJoin = this.toDate;
        params.fromDate = this.searchDate[0];
        params.toDate = this.searchDate[1];
      } else {
        params.fromDate = null;
        params.toDate = null;
      }
      params.searchDate = this.searchDate;
      return params;
    },
    createForm(){
      this.$router.push({path: `/user/form/`})
      // this.selectedUser = {};
      // this.dialogVisible = true;
      // this.$router.push({path: '/user/form'})
    },
    savedUser() {
      this.dialogVisible = false;
      this.search();
    },
    updateForm(item) {
      this.$router.push({path: `/user/form/${item.userId}`})
      // this.selectedUser = _.cloneDeep(item);
      // this.dialogVisible = true;
    },
    deleteUser(item) {
      if(confirm('삭제하시겠습니까?')) {
        userApi.delete(item.userId).then(() => {
          this.search();
          // this.datas = this.datas.filter(d => d.menu !== item.menu && d.request_type !== item.request_type);
        });
      }
    },
    groupSetting(item) {
      this.selectedUser = _.cloneDeep(item);
      this.groupDialogVisible = true;
    },
    updateState(state, userId) {
      const stateText = this.userStateItems.filter(i => i.value === state)[0].text;

      if(!this.all && this.selected.length === 0 && !userId) {
        alert(stateText + " 상태로 변경할 회원을 선택해주세요.");
        return;
      }
      if(confirm(stateText + ' 상태로 변경하시겠습니까?')) {
        if(this.all) {
          const params = this.generateParameters();
          userApi.updateStateAll(params, state).then(() => {
            alert("변경 되었습니다.");
            this.search();
          });
        } else {
          // console.log(this.selected.map(u => u.userId));
          userApi.updateState([...this.selected.map(u => u.userId), userId], state).then(() => {
            alert("변경 되었습니다.");
            this.search();
          });
        }
        // userApi.updateState(s).then(() => {

        // });
      }
    },
    changedUserGroupState(item, groupId, state) {
      let filteredUser = this.users.filter(u => u.userId === item.userId)?.[0]?? null;

      let department = filteredUser?.departmentGroup.filter(g => g.groupId === groupId)?.[0]??null;
      if(department)
        department.joinState = state;

      let club = filteredUser?.clubGroup.filter(g => g.groupId === groupId)?.[0]??null;
      if(club)
        club.joinState = state;
    },
    async excel() {

      const passwd = prompt('엑셀에 설정할 패스워드를 입력하세요.', '');

      const params = this.generateParameters();

      let prefix = (this.userStateItems.filter(s => s.value === params.searchState)?.[0]??{text:'전체 '}).text;

      let roleName = (this.userRoleItems.filter(r => r.roleId === params.searchRole)?.[0]??{roleName:''}).roleName;
      let clubName = (this.clubItems.filter(r => r.groupId === params.searchClub)?.[0]??{groupName:''}).groupName;
      let departmentName = (this.departmentItems.filter(r => r.groupId === params.searchDepartment)?.[0]??{groupName:''}).groupName;
      let dateName = (this.searchDate && this.searchDate.length > 0) ? params.fromDate + '_' + params.toDate : '';

      const suffix = ((roleName) ? "_" + roleName : '') + ((clubName) ? "_" + clubName : '') + ((departmentName) ? "_" + departmentName : '') +((dateName) ? "_" + dateName : '');

      params.excelPassword = passwd;

      await userApi.excel(params, prefix, suffix);
    }
  },
  created: function () {

    const storedParams = this.$store.getters?.params??{};
    if(storedParams.name !== this.$options.name || storedParams.searchState !== this.$route.params.state)
      this.$store.commit('setParams', Object.assign(this.param, {name:this.$options.name}))
    else {
      this.options = storedParams
      this.param = storedParams
      this.searchValue = this.param.searchKeyword
    }

    this.param.searchState = this.$route.params.state;
    this.userStateItems.forEach(i => {
      if(this.param.searchState) {
        if (i.value === this.param.searchState) {
          this.currentStateName = i.text;
        }
      }
    });

    if(['STATE_REQUEST', 'STATE_DORMANT'].includes(this.$route.params.state)) {
      const lastHeaderItem = this.headers.pop();
      this.headers = [...this.headers, {text: this.$route.params.state === 'STATE_DORMANT' ? '휴면해제' : '가입승인', value: 'stateChange', align: 'center', sortable: false}, lastHeaderItem];
    }
    if(!this.$route.params.state) {
      this.headers = [{text: '회원상태', value: 'state', align: 'center', sortable: false}, ...this.headers]
    }

    this.headers = this.headers.map(h => {
      if(h.value === 'createdAt') {
        h.value = 'stateChangedAt';
        switch (this.$route.params?.state ?? '') {
          case 'STATE_DORMANT':
            h.text = '휴면 전환일';
            break;
          case 'STATE_WITHDRAW_REQUEST':
            h.text = '탈퇴 요청일';
            break;
          case 'STATE_WITHDRAW':
            h.text = '탈퇴일';
            break;
          case 'STATE_BLOCKED':
            h.text = '차단일';
            break;
          default:
            h.text = '가입일';
            h.value = 'createdAt';
        }
      }

      return h;
    });

    roleApi.list(true).then(data => {
      this.userRoleItems = data;
    });
    // this.search();
    // userApi.list(this.param).then(data => {
    //   this.users = data.content;
    //   this.totalItems = data.totalElements;
    // });

    groupApi.flatActiveList(1).then(data => {
      this.departmentItems = data;
    });
    groupApi.flatActiveList(2).then(data => {
      this.clubItems = data;
    });


  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/layout/variables';

.h2Title {
  @include h2-title;
}

.fieldWrap {
  @include form-bx;

  .fieldBx {
    position: relative;
    width: 1600px;

    .searchBtn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 1.7%;
    }

    .formList {
      display: flex;
      flex-direction: row;
      margin-bottom: 10px;

      dl {
        display: flex;
        align-items: center;
        flex-direction: row;
        margin-right: 20px;

        .formTit {
          @include form-font;
        }

        dd {
          display: flex;
          align-items: center;

          span {
            margin-left: 8px;
          }

          &:nth-child(2) {
            padding-left: 3px;
            padding-bottom: 3px;
          }

          .monthBx {
            display: flex;
            align-items: center;
            height: 35px;
            width: 280px;
            border-radius: 3px;
            border: 1px solid #1867c0;

            .month {
              &:first-child {
                padding-left: 10px;
              }
              width: 55px;
              height: 100%;
              padding: 0 8px;
              border: 0;
              background: #fff;
              font-size: 13px;
              font-weight: normal;
              color: #1867c0;

              &.active {
                background: #1867c0;
                color: #fff;
              }
            }
          }
        }
      }
    }
  }
}

.tableWrap {
  .tableBtnBx {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .searchAll {
      display: flex;
      align-items: center;
      margin-bottom: 0;
      /*font-size: 13px;*/
      .txtPoint {
        color: $point-color;
      }
    }
  }

  .tableBtn {
    ul {
      display: flex;
      flex-direction: row;
      align-items: center;

      .tableBtnList {
        margin-right: 15px;
      }
    }
  }
}
</style>
